<div fxLayout="row" style="padding: 20px 10px 20px 10px;">
    <div class="center-vertical" fxFlex="40%">
        <p>Total: {{ showedRows.length}} sur {{totalRows}}</p>
    </div>
    <!-- <div class="center-vertical" fxFlex="20%" fxLayoutAlign="center center">
        <button type="button" class="button-secondary-small" (click)="depInsModSetting()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
            <mat-icon fontIcon="add" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
            <div>Add New</div>
        </button>
    </div> -->
    <div class="center-vertical" fxFlex="20%" fxLayoutAlign="center center">
        <button type="button" class="button-secondary-small" (click)="depInsModSetting()"  style="white-space: nowrap; align-items: center; display: flex; margin-right: 3px;">
            <mat-icon fontIcon="settings" style="color: gray; cursor: pointer; margin-right: 5px; font-size: 20px; width: fit-content; height: fit-content;"></mat-icon>
            <div>Setting Content</div>
        </button>
    </div>
</div>

<div class="table_div" style="height: calc(100% - 170px);">
    <div class="nav-preview" fxLayout="row" fxLayoutAlign="center center" style="float: bottom; position: absolute;">
        <mat-icon [ngClass]="navIndex === 0 ? 'nav-inactive' : 'nav-active'"style="padding: 0px 14px 0px 0px; font-size: 40px; height: 40px;" fontIcon="arrow_left" title="Previous" (click)="movePrevNextNavigation('prev')"></mat-icon>
        <span style="font-weight: bold;"> Nav {{ navIndex *  this.filterData.limit}} / {{ totalRows}}</span>
        <mat-icon [ngClass]="navIndex === totalNavigations - 1 ? 'nav-inactive' : 'nav-active'" style="padding-right: 10px; font-size: 40px; height: 40px;" fontIcon="arrow_right" title="Next" (click)="movePrevNextNavigation('next')"></mat-icon>
    </div>
    <table>
        <thead>
        <tr>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id_parent', 'number')"></mat-icon>
                <div class="column-name">Id {{manageKeyValue?.[manageKey]?.parent ?? 'Element'}}</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id_parent')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'parent_name', 'string')"></mat-icon>
                <div class="column-name">{{manageKeyValue?.[manageKey]?.parent ?? 'Element'}}</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'parent_name')">
            </th>
            <th *ngIf="manageKey == 'vca_department'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'cycle_name', 'string')"></mat-icon>
                <div class="column-name">Cycle</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'cycle_name')">
            </th>
            <th *ngIf="manageKey == 'vca_module'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'semester', 'string')"></mat-icon>
                <div class="column-name">Semester</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'semester')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'id', 'number')"></mat-icon>
                <div class="column-name">Id</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'id')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'name', 'string')"></mat-icon>
                <div class="column-name">{{manageKeyValue?.[manageKey]?.element ?? 'Element'}} Name</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'name')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'full_name', 'string')"></mat-icon>
                <div class="column-name">{{manageKeyValue?.[manageKey]?.element ?? 'Element'}} Full Name</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'full_name')">
            </th>
            <th *ngIf="manageKey != 'vca_department'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'type', 'string')"></mat-icon>
                <div class="column-name">Type</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'type')">
            </th>
            <th *ngIf="manageKey == 'vca_module'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'credit', 'number')"></mat-icon>
                <div class="column-name">Credit</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'credit')">
            </th>
            <th *ngIf="manageKey == 'vca_institution'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_structure', 'number')"></mat-icon>
                <div class="column-name">Nb Structure</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_structure')">
            </th>
            <th *ngIf="['vca_institution', 'vca_structure'].includes(manageKey)">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_department', 'number')"></mat-icon>
                <div class="column-name">Nb Department</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_department')">
            </th>
            <th *ngIf="manageKey != 'vca_module'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_module', 'number')"></mat-icon>
                <div class="column-name">Nb Module</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_module')">
            </th>
            <th *ngIf="manageKey != 'vca_module'">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_student', 'number')"></mat-icon>
                <div class="column-name">Nb Student</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_student')">
            </th>
            <th *ngIf="['vca_institution', 'vca_structure'].includes(manageKey)">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_raw', 'number')"></mat-icon>
                <div class="column-name">Nb Raw</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_raw')">
            </th>
            <th *ngIf="['vca_institution', 'vca_structure'].includes(manageKey)">
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_proj_content', 'number')"></mat-icon>
                <div class="column-name">Nb Proj Cont</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_proj_content')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'nb_content', 'number')"></mat-icon>
                <div class="column-name">Nb Content</div>
                <input matInput class="col-input" (keyup)="applyFilterLocal($event.target, 'nb_content')">
            </th>
            <th>
                <mat-icon  sorted="" fontIcon="sort" (click)="applySortLocal($event.target, 'status', 'string')"></mat-icon>
                <div class="column-name">Status</div>
                <mat-select placeholder="Choose" style="height: 22px;" (selectionChange)="applyFilterLocal($event, 'status')">
                    <mat-option [value]="''">Choose</mat-option>
                    <mat-option [value]="'valid'">Valid</mat-option>
                    <mat-option [value]="'obsolete'">Obsolete</mat-option>
                    <mat-option [value]="'new'">New</mat-option>
                    <mat-option [value]="'update'">Update</mat-option>
                </mat-select>
            </th>
            <th>
                <div style="display: flex; justify-content: center;"><input #checkedAllRef type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" (change)="selectAllOption($event.target)"></div>
            </th>
        </tr>
        </thead>
        <tbody #row_tbody *ngFor="let row of showedRows; let i = index">
            <tr (click)="toggleRow(row, $event.target, row_tbody)" [ngClass]="{'highlight-previous': ['new', 'update'].includes(row['status'])}">
                <td>{{ row['id_parent'] }}</td> 
                <td matTooltip="{{ row['parent_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['parent_name'] }}</td> 
                <td *ngIf="manageKey == 'vca_module'">{{ row['semester'] }}</td>
                <td *ngIf="manageKey == 'vca_department'">{{ row['cycle_name'] }}</td>
                <td>{{ row['id'] }}</td> 
                <td>{{ row['name'] }}</td>
                <td matTooltip="{{ row['full_name'] }}" matTooltipPosition="below" matTooltipTouchGestures="off">{{ row['full_name'] }}</td>
                <td *ngIf="manageKey != 'vca_department'">{{ row['type'] }}</td>
                <td *ngIf="manageKey == 'vca_module'">{{ row['credit'] }}</td>
                <td *ngIf="manageKey == 'vca_institution'">{{ row['nb_structure'] }}</td>
                <td *ngIf="['vca_institution', 'vca_structure'].includes(manageKey)">{{ row['nb_department'] }}</td>
                <td *ngIf="manageKey != 'vca_module'">{{ row['nb_module'] }}</td>
                <td *ngIf="manageKey != 'vca_module'">{{ row['nb_student'] }}</td>
                <td *ngIf="['vca_institution', 'vca_structure'].includes(manageKey)">{{ row['nb_raw'] }}</td>
                <td *ngIf="['vca_institution', 'vca_structure'].includes(manageKey)">{{ row['nb_proj_content'] }}</td>
                <td>{{ row['nb_content'] }}</td>
                <td >{{ row['status']}}</td>
                <td class="to_skip_element select_container">
                    <div *ngIf="row['nb_duplicate'] > 1" class="duplicate-mark"></div>
                    <div style="display: flex;">
                        <input type="checkbox" class="form-check-input" style="font-size:large; cursor: pointer;" (change)="selectRow($event.target, i)" [checked]="row['checked']">
                        <mat-icon sorted="" fontIcon="more_vert" style="color: gray; font-size: 20px;" (click)="depInsModOption(row)"></mat-icon>
                    </div>
                </td>
            </tr>
            <tr class="expand_detail" *ngIf="row['expanded']">
                <td colspan="15">
                    <app-vca-detail-dep-mod [rowInfos]="row" [userInfos]="userInfos" [filterData]="filterData" [manageKey]="manageKey" [action]="'update'" [manageKeyValue]="manageKeyValue" [metaData]="metaData" [mergeData]="mergeData" [platformInfos]="platformInfos" (inProgress)="setWaiting($event)" (updateRow)="setUpdatedRow($event)"></app-vca-detail-dep-mod>
                </td>
            </tr>
        </tbody>
        <tbody *ngIf="showedRows.length === 0">
            <tr ><td colspan="15" style="text-align: center;">No matching records found</td></tr>
        </tbody>
    </table>
</div>